import React from 'react'
import RemoteConfiguration from '../../../components/sdk/RemoteConfiguration';
import { useParams } from 'react-router-dom';
import { useGetAppAdminQuery } from '../../../api/appAdminApiSlice';
import AppABRemoteConfiguration from '../../../components/sdk/AppABRemoteConfiguration';

const AppRemoteConfiguration = () => {
  const appId = useParams()["appId"];
  const { data: app={}, isSuccess, isError, retry } = useGetAppAdminQuery(appId)

  if (! (app.bundle_id || app.bundle_id || app.devices ) ) { return(<></>) }

  return <>
    <RemoteConfiguration configurable={{...app, remote_configurable_id: appId, remote_configurable_type: 'App',}}/>
    <AppABRemoteConfiguration appId={appId}/>
  </>;
}

export default AppRemoteConfiguration